import {
  JbUpload
} from "./chunk.7FS4EKVD.js";
import {
  JbTimePicker
} from "./chunk.6EJGOISX.js";
import {
  JbTextField
} from "./chunk.FLMZQVUX.js";
import {
  JbTextArea
} from "./chunk.CRWKUKJJ.js";
import {
  JbRadio
} from "./chunk.YA4KSCD3.js";
import {
  JbMultiCheckbox
} from "./chunk.LF6AZRZB.js";
import {
  JbInfoBox
} from "./chunk.APKGNP4I.js";
import {
  jb_form_css_default
} from "./chunk.WWJNMD4Z.js";
import {
  JbSelect
} from "./chunk.5WUIBHIZ.js";
import {
  JbDatePicker
} from "./chunk.QXKHP25U.js";
import {
  JbRichtext
} from "./chunk.KMSQR6FW.js";
import {
  JbCheckbox
} from "./chunk.USKOJ5I2.js";
import {
  JbButtonPrimary
} from "./chunk.3I2URAFM.js";
import {
  Spaceable,
  setLink
} from "./chunk.P6YYTXAQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-form/jb-form.ts
var JbForm = class extends Initiable(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.bordered = false;
    this.displayGrid = true;
  }
  static create(formProperties) {
    return new JbForm().init({
      props: formProperties
    });
  }
  updated(_changedProperties) {
    if (!_changedProperties.has("contentElements")) return;
    this._generateForm();
  }
  async firstUpdated() {
    if (this.trackingSubject) {
      const componentObserver = new IntersectionObserver(
        async (entries, observer) => {
          if (entries[0].isIntersecting) {
            this.dispatchEvent(
              new CustomEvent("jb-tracking", {
                detail: {
                  event: "ce_form",
                  event_version: "v2",
                  component_name: "contact-form",
                  form_component: this,
                  form_step_name: "form open",
                  form_step_nr: "1",
                  form_subject: this.trackingSubject,
                  form_type: "contact"
                },
                bubbles: true,
                composed: true
              })
            );
            observer.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
      componentObserver.observe(this);
    }
    this._populateReferrerFields();
    this.addEventListener("field-update", (event) => {
      this._storeFieldsToLocalStorage(
        event.detail.field,
        event.detail.changedProperties
      );
    });
    await this.updateComplete;
    this._lastUpdated = Date.now();
    window.parent.postMessage(`formLoaded_${this.formIdentifier}`);
  }
  refreshValues() {
    this._slottedChildren.forEach((elm) => {
      const el = elm;
      if (el.populateValue && el.populateValue()) {
        el.populateValue();
      }
    });
  }
  validate() {
    let isValid = true;
    this._slottedChildren.forEach((child) => {
      if (child.validate) {
        isValid = child.validate() && isValid;
      }
    });
    return isValid;
  }
  _clearStoredData() {
    localStorage.removeItem("savedFormData");
  }
  // Method to generate the form components according to the contentElements property and add them to the slot
  _generateForm() {
    if (!this.contentElements || this.contentElements.length === 0) return;
    while (this.firstChild) {
      this.removeChild(this.firstChild);
    }
    let elm;
    this.contentElements.forEach((element) => {
      if (element.name === "formRow") {
        elm = document.createElement("div");
        elm.classList.add("combine");
        element.items?.forEach((singleElement) => {
          const formElm = this._makeFormElement(singleElement);
          if (!formElm) return;
          elm.appendChild(formElm);
        });
      } else {
        elm = this._makeFormElement(element);
      }
      if (!elm) return;
      this.appendChild(elm);
    });
  }
  _getContentSpacingProperties() {
    if (this.bordered) {
      return { grid: "legacy", colsMdUp: 8 };
    }
    return { grid: "legacy", colsMdUp: 8, colsLgUp: 6 };
  }
  _makeFormElement(componentProp) {
    const componentConstructor = {
      checkbox: JbCheckbox,
      datePicker: JbDatePicker,
      infoBox: JbInfoBox,
      multiCheckbox: JbMultiCheckbox,
      radio: JbRadio,
      richText: JbRichtext,
      select: JbSelect,
      submitButton: JbButtonPrimary,
      textArea: JbTextArea,
      textField: JbTextField,
      timePicker: JbTimePicker,
      upload: JbUpload
    };
    if (!(componentProp.name in componentConstructor)) return void 0;
    const ComponentClass = componentConstructor[componentProp.name];
    const componentInstance = new ComponentClass().init({
      props: componentProp.componentProperties,
      innerHTML: componentProp.innerHTML,
      childNodes: componentProp.childNodes,
      attributes: componentProp.attributes
    });
    return componentInstance;
  }
  _notifyCustomElements(e2) {
    this._slottedChildren.forEach((child) => {
      if (child.appendFormData) {
        child.appendFormData(e2);
      }
    });
  }
  _populateReferrerFields() {
    const params = new URLSearchParams(document.location.search.substring(1));
    if (this._referrerOriginalUrlField) {
      this._referrerOriginalUrlField.value = params.get("referrerOriginalUrl") || localStorage.getItem("page_url_english") || "";
    }
    if (this._referrerUrlField) {
      this._referrerUrlField.value = params.get("referrerUrl") || window.location.href;
    }
    if (this._referrerTitleField) {
      this._referrerTitleField.value = params.get("referrerTitle") || document.title;
    }
  }
  _renderHiddenFields() {
    if (this.additionalData === void 0 || Object.keys(this.additionalData).length === 0) {
      return D;
    }
    return Object.keys(this.additionalData).map(
      (key) => ke`
        <input
          type="hidden"
          name="${key}"
          value="${this.additionalData ? this.additionalData[key] : ""}"
        />
      `
    );
  }
  _renderPhone(phoneString) {
    const phoneNumber = phoneString.match(/(?:[-+() ]*\d){10,13}/g);
    if (phoneNumber === null || phoneNumber[0] === null) return null;
    const anchor = document.createElement("a");
    const paragraph = document.createElement("p");
    anchor.innerText = phoneNumber[0].trim();
    setLink(anchor, { href: `tel:${phoneNumber[0].replace(/[^+1-9]/g, "")}` });
    paragraph.innerText = phoneString.replace(phoneNumber[0], "") + " ";
    paragraph.appendChild(anchor);
    return paragraph;
  }
  _renderValidationFields() {
    return ke`
      <label
        class="internal"
        for="${this.validationFieldname}"
        >${this.validationFieldname}</label
      >
      <input
        type="text"
        name="${this.validationFieldname}"
        id="${this.validationFieldname}"
        class="internal"
        autocomplete="off"
        tabindex="-1"
        value=""
        maxlength="512"
      />
    `;
  }
  get _slottedChildren() {
    const returnArray = [];
    const slot = this.shadowRoot.querySelector("slot");
    slot.assignedElements({ flatten: true }).forEach((singleElement) => {
      if (singleElement.classList.contains("combine")) {
        singleElement.childNodes.forEach((child) => {
          returnArray.push(child);
        });
      } else {
        returnArray.push(singleElement);
      }
    });
    return returnArray;
  }
  _storeFieldsToLocalStorage(element, changedProperties) {
    if (changedProperties.has("value") && element.frontendRenderingIdentifier && typeof element.value === "string" && element.name.indexOf("checkbox") === -1) {
      let storedData = localStorage.getItem("savedFormData");
      if (storedData !== null) {
        storedData = JSON.parse(storedData);
      } else {
        storedData = {};
      }
      storedData[element.frontendRenderingIdentifier] = element.value;
      localStorage.setItem("savedFormData", JSON.stringify(storedData));
    }
  }
  _submit(e2) {
    const timeField = this.renderRoot.querySelector('input[name="form_analytics_time"]');
    const timeTaken = Date.now() - this._lastUpdated;
    if (timeField) {
      timeField.value = String(timeTaken);
    }
    if (e2.detail.name === "submit") {
      this._submitButton.click();
    }
  }
  _submitIfValid(e2) {
    const isValid = this.validate();
    if (!isValid) {
      e2.preventDefault();
    } else {
      this._submitButton.setAttribute("disabled", "disabled");
      this._clearStoredData();
      this.dispatchEvent(new CustomEvent("jb-form:submit", { detail: e2 }));
    }
  }
  render() {
    const sectionHeadline = this.sectionHeadline ? ke`<jb-section-headline .headline=${this.sectionHeadline.headline}></jb-section-headline>` : D;
    const formHeader = this.generalConcern || this.recipient ? ke`<div class="formheader">
              <p class="general-concern">${this.generalConcern}</p>
              ${this.recipient ? ke`<h5>${this.recipient}</h5>` : D}
              ${this.recipientPosition ? ke`<p>${this.recipientPosition}</p>` : D}
              ${this.recipientPhone ? this._renderPhone(this.recipientPhone) : D}
            </div>
            ${this.formHeader ? ke`<h3>${this.formHeader}</h3>` : D}` : D;
    return ke`${sectionHeadline} ${formHeader}
      <form
        @formdata=${this._notifyCustomElements}
        @submit=${this._submitIfValid}
        action=${this.action}
        class="${Rt({ bordered: !!this.bordered })}"
        enctype="multipart/form-data"
        method="post"
      >
        ${this._renderHiddenFields()}
        <slot
          class="${Rt({ grid: !!this.displayGrid, flex: !this.displayGrid })}"
          @jb-button:clicked=${this._submit}
        ></slot>
        ${this.validationFieldname ? this._renderValidationFields() : D}
        <input
          type="hidden"
          class="internal"
          name="form_analytics_time"
          id="form_analytics_time"
        />
        <button
          type="submit"
          class="hidden"
        ></button>
      </form>`;
  }
};
JbForm.styles = jb_form_css_default;
JbForm.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbForm.prototype, "action", 2);
__decorateClass([
  n({ type: Object })
], JbForm.prototype, "additionalData", 2);
__decorateClass([
  n({ type: Boolean })
], JbForm.prototype, "bordered", 2);
__decorateClass([
  n({ type: Array })
], JbForm.prototype, "contentElements", 2);
__decorateClass([
  n({ type: Boolean })
], JbForm.prototype, "displayGrid", 2);
__decorateClass([
  n()
], JbForm.prototype, "formHeader", 2);
__decorateClass([
  n()
], JbForm.prototype, "formIdentifier", 2);
__decorateClass([
  n()
], JbForm.prototype, "generalConcern", 2);
__decorateClass([
  n()
], JbForm.prototype, "multiformSubline", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipient", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipientPhone", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipientPosition", 2);
__decorateClass([
  n({ type: Object })
], JbForm.prototype, "sectionHeadline", 2);
__decorateClass([
  n()
], JbForm.prototype, "trackingSubject", 2);
__decorateClass([
  n()
], JbForm.prototype, "validationFieldname", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerOriginalUrl]"]')
], JbForm.prototype, "_referrerOriginalUrlField", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerTitle]"]')
], JbForm.prototype, "_referrerTitleField", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerUrl]"]')
], JbForm.prototype, "_referrerUrlField", 2);
__decorateClass([
  e('button[type="submit"].hidden')
], JbForm.prototype, "_submitButton", 2);
JbForm = __decorateClass([
  customElement("jb-form")
], JbForm);

export {
  JbForm
};
